var map = {
	"./1.mp3": 64735,
	"./2.mp3": 10675,
	"./3.mp3": 73900,
	"./4.mp3": 87609,
	"./5.mp3": 79380,
	"./6.mp3": 20455,
	"./7.mp3": 77644,
	"./8.mp3": 32187,
	"./9.mp3": 7650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24080;